;(function() {
  'use strict'

  angular.module('glow.reporting.charts', [])
})()
